import { Linking, TouchableOpacity, View } from "react-native"
import { Body, H1, H3, Tiny } from "@/components/standard/BFText"
import RewardMoney from "@/assets/clipart/reward-money.svg"

export const RewardsTab: React.FC = () => {
  return (
    <View className="flex flex-col items-center justify-start flex-1 py-6">
      <H1 className="text-calm-blue text-center">
        Refer Friends,{"\n"}Earn Up to $1,500
      </H1>
      <H3 className="text-calm-blue text-center mt-1">
        (On your first close!)
      </H3>
      <View className="my-6">
        <RewardMoney width={152} height={105} />
      </View>
      <H3 className="text-calm-blue text-center w-[270px]">
        You automatically received 10 referrals to get started
      </H3>
      <Body className="text-midnight-blue text-center w-[250px] pt-4">
        {`Earn rewards for closing deals, referring friends, and more!
        Turn actions you do already into credit towards loan closing costs.`}
      </Body>
      <View className="flex flex-col items-center justify-end flex-1 w-full pb-6 ">
        <TouchableOpacity
          testID={"terms-and-conditions-link"}
          onPress={() => {
            void Linking.openURL(
              "https://dobackflip.com/backflip-rewards/?appDisplay=true"
            )
          }}
        >
          <Tiny className="text-calm-blue underline pt-6">
            See Terms & Conditions
          </Tiny>
        </TouchableOpacity>
      </View>
    </View>
  )
}
